// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-panel[data-v-4fee2ad8]{min-height:50px;overflow:hidden;margin-bottom:10px}.header-panel.with-background[data-v-4fee2ad8]{background-color:#E2E2E2;padding:5px}.header-panel__header_title[data-v-4fee2ad8]{font-size:24px;font-weight:bold;vertical-align:middle}.header-panel__header_title.underlined[data-v-4fee2ad8]{text-decoration:underline}@media (max-width: 767px){.header-panel__panel-right[data-v-4fee2ad8]{margin-top:5px}}\n", ""]);
// Exports
module.exports = exports;
